import { HttpMethod } from "~/extensions/api/HttpMethod";
import { UploadCommand } from "~/extensions/api/UploadCommand";
export class InsertFile extends UploadCommand {
    constructor() {
        super(HttpMethod.Post, "taikyonotification/file/upload");
    }
    /** オリジナル入居契約No. */
    targetNo = -1;
    /** ファイル情報リスト */
    fileList = [];
    /** ファイル情報リスト */
    files = [];
    static create(taikyoNo, files, fileInfoList) {
        const command = new InsertFile();
        command.targetNo = taikyoNo;
        command.fileList = fileInfoList;
        command.files = files;
        return command;
    }
}
